import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch'

const LightBlueSwitch = withStyles({
	switchBase: {
	  '&$checked': {
		color: '#3e9bbe',
		'& + $track': {
		  backgroundColor: '#3e9bbebf',
		  opacity: 1,
		  border: 'none',
		}
	  },
	  '&$checked + $track': {
		color: '#3e9bbe',
	  }
	},
	checked: {},
	track: {},
})(Switch);

export default LightBlueSwitch